import React, { useEffect, useState } from "react"
import Login from "./components/Login/Login"
import { Routes, Route } from "react-router-dom"
import toast from "react-hot-toast"
import Home from "./components/Home/Home"

export interface UserInterface {
    _id: string
    authToken: string
    files?: any[]
    name: string
    email: string
    managing: string[]
    success: boolean
}

export interface StoreDetailsInterface {
    name: string
    created: number
    apiKey: string
    owners: string[]
    contact: string
    description: string
    banner: string
    icon: string
    location: string
}

const App: React.FC = () => {
    const [user, setUser] = useState<UserInterface>({} as UserInterface)
    const [entryType, setEntryType] = useState<"login" | "register">("login")

    useEffect(() => {
        if (user.success) {
            toast.dismiss()
            window.location.href = "#/"
            localStorage.setItem("credentials", JSON.stringify(user))
        }
    }, [user])

    useEffect(() => {
        const credentials = localStorage.getItem("credentials")
        if (credentials) {
            const parsedCredentials = JSON.parse(credentials)
            setUser(parsedCredentials)
        }
    }, [])

    return (
        <Routes>
            <Route path="/" element={<Home setUser={setUser} user={user} />} />
            <Route
                path="/login"
                element={
                    <Login setUser={setUser} entryType={entryType} setEntryType={setEntryType} />
                }
            />
        </Routes>
    )
}

export default App
